import { useEffect, useRef } from 'react';

interface InViewportOptions extends IntersectionObserverInit {
  onInView?: () => void;
  onOutView?: () => void;
  once?: boolean;
}

export function InViewport({
  onInView,
  onOutView,
  once = false,
  ...options
}: InViewportOptions = {}) {
  const ref = useRef<HTMLDivElement | null>(null);
  const hasTriggered = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry?.isIntersecting) {
        if (!once || !hasTriggered.current) {
          onInView?.();
          hasTriggered.current = true;
        }
      } else {
        onOutView?.();
      }
    }, options);

    observer.observe(el);
    return () => {
      observer.disconnect();
    };
  }, [onInView, onOutView, once, options]);

  return <div ref={ref} />;
}
